import { useCallback, useState } from 'react';
import { TInterceptor } from '../types/internal';

export const useBackInterceptor = () => {
  const [backInterceptor, setBackInterceptor] = useState<TInterceptor | null>(null);

  const registerBackInterceptor = useCallback((callback: TInterceptor) => {
    setBackInterceptor(() => callback);
  }, []);

  const unRegisterBackInterceptor = useCallback(() => {
    setBackInterceptor(null);
  }, []);

  return {
    backInterceptor,
    registerBackInterceptor,
    unRegisterBackInterceptor,
  };
};
